<template>
	<AsiDialogFormLayout :icon="icons.state" :title="$t('item.state')"
	                     :open="open" :loading="loading" :valid="valid" :errors="errors"
	                     @save="requestSave" @cancel="cancel" unwrapped scrollable>
		<v-card-text class="pa-6">
			<v-form v-model="valid">
				<v-row>
					<v-col>
						<AsiSelect v-model="state" :label="$t('item.state')" :placeholder="$t('item.state')"
						           :items="options" :rules="rules"/>
					</v-col>
				</v-row>
			</v-form>
		</v-card-text>
	</AsiDialogFormLayout>
</template>

<script lang="ts">
	import {Component, Emit, Prop, Watch} from "vue-property-decorator";
	import AsiDialogFormLayout from "@/components/common/AsiDialogFormLayout.vue";
	import AsiSelect from "@/components/common/AsiSelect";
	import AsiDialogForm from "@/components/common/AsiDialogForm.vue";
	import {ItemState} from "@/helpers/constants";
	import EnumHelper from "@/helpers/EnumHelper";
	import {ValidationRule} from "@/declarations/ValidationRule";
	import {IItemShopSimple} from "@/models/item/ItemShopModels";
	import ItemRules from "@/models/item/ItemRules";
	@Component({
		components: {AsiSelect, AsiDialogFormLayout}
	})
	export default class ItemUpdateDialogState extends AsiDialogForm {
		@Prop({type: Object, required: true})
		public item!: IItemShopSimple;

		private state: ItemState | null = null;

		// noinspection JSMethodCanBeStatic
		private get options(): { text: string, value: string | number }[] {
			return EnumHelper
				.toSelectItems(ItemState, true);
		}

		// noinspection JSMethodCanBeStatic
		private get rules(): ValidationRule[] {
			return ItemRules.stateRules;
		}

		@Watch('item.state', {immediate: true})
		private onItemStateChanged(value: ItemState): void {
			this.state = value;
		}

		@Emit('save')
		public save(): void {
			return;
		}

		@Emit('cancel')
		public cancel(event: Event): Event {
			this.state = this.item.state;
			const form = this.$refs.form as HTMLFormElement;
			this.reset([], form);
			return event;
		}

		private requestSave(): void {
			if (this.state === null) return;

			this.loading = true;
			this.$itemServiceAdmin.updateState(this.item.id, this.state)
				.then(this.save)
				.catch(this.handleErrors)
				.finally(() => this.loading = false);
		}
	}
</script>

<style lang="scss" scoped>

</style>
